declare namespace $ {

	export class $mol_icon_format_paragraph extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=paragraph.view.tree.d.ts.map